import * as icons from '@fortawesome/free-solid-svg-icons';

export const fastIconList = Object.keys(icons)
  .filter(key => key !== 'fas' && key !== 'prefix')
  .map(key => ({
    name: key,
    icon: icons[key as keyof typeof icons] as icons.IconDefinition
  }));
